// src/components/bxpart/BxpartEdit.jsx
import React, { useEffect, useState, useRef } from "react";
import { Container, Spinner, Alert } from "react-bootstrap";
import { authFetch } from "../utils/authFetch";
import { useParams } from "react-router-dom";
import ArticleConversion from "../simaus/ArticleConversion";
import BxpartEditV1 from "./BxpartEditV1";
import BxpartEditV2 from "./BxpartEditV2";
import EnvironmentalFee from "./EnvironmentalFee";

export default function BxpartEdit() {
  const { id } = useParams();
  const conversionRef = useRef(null);
  const feeRef = useRef(null);
  const saveConversion = async () => {
    await feeRef.current?.saveIfChanged();
    if (simaus) {
      if (!conversionRef.current) throw new Error("Conversia se încarcă. Încercați din nou.");
      await conversionRef.current.saveIfChanged();
    }
  };
  const [simaus, setSimaus] = useState(false);
  const [loading, setLoading] = useState(true);
  const [verParts, setVerParts] = useState(1);
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const company = await authFetch("/firma/1");
        if (company) {
          setSimaus(company.app_variant === "SIMAUS");
          const isLite = (company.app_variant || "").toUpperCase() === "LITE" || company.ver_parts === 1;
          setVerParts(isLite ? 1 : company.ver_parts);
        }
      } catch (e) {
        console.error("Failed to load company config:", e);
        setErr("Eroare la încărcarea configurării firmei.");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  if (loading) {
    return (
      <Container className="mt-4 text-center">
        <Spinner animation="border" size="sm" /> Se încarcă configurările…
      </Container>
    );
  }

  if (err) {
    return (
      <Container className="mt-4">
        <Alert variant="danger">{err}</Alert>
      </Container>
    );
  }

  if (verParts === 2) {
    return <><BxpartEditV2 beforeSave={saveConversion} /><Container><EnvironmentalFee key={id} ref={feeRef} partId={id}/></Container>{simaus && <Container><ArticleConversion key={id} ref={conversionRef} partId={id}/></Container>}</>;
  }

  return <><BxpartEditV1 beforeSave={saveConversion} /><Container><EnvironmentalFee key={id} ref={feeRef} partId={id}/></Container>{simaus && <Container><ArticleConversion key={id} ref={conversionRef} partId={id}/></Container>}</>;
}
